import BoundaryFallback from './errorComponent'
import FittedFallbackComponent from './fallbackComponent'
import SimpleErrorBoundary from './simpleErrorBoundary'
import type { AnyComponent, BoundaryProps } from './types'

const getErrorBoundary = (fit = false): AnyComponent => {
  return function ErrorBoundaryWrapper({
    children,
    fallbackComponent,
    onError,
  }: BoundaryProps) {
    return (
      <SimpleErrorBoundary
        fallbackComponent={fallbackComponent}
        defaultFallbackComponent={
          fit ? FittedFallbackComponent : BoundaryFallback
        }
        onError={onError}
      >
        {children}
      </SimpleErrorBoundary>
    )
  }
}

export default getErrorBoundary
